import request from "../../../utils/request";
import moment from "moment";
import { cacheTime } from "../../../utils/constant";
import lodash from "lodash";
import { filter } from "../../../utils/search";

export const criteriaIgnore = ["totalPage", "totalSize", "data"];

export default class {
    constructor(baseUrl) {
        this.request = request;
        this.state = {
            list: [],
            cacheDate: {
                list: null
            }
        };
        this.getters = {
            /*
            getListBy(state) {
                return where => filter(state.list, where)
            }
            */
        };
        this.actions = {
            save(context, { data, config }) {
                return request.put(`${baseUrl}`, data, { ...config });
            },
            saveAll(context, { data, config }) {
                return request.put(`${baseUrl}/_all`, data, { ...config });
            },
            search(context, { criteria, config }) {
                criteria = lodash.cloneDeepWith(criteria, (value, key) => {
                    if (criteriaIgnore.includes(key)) {
                        return null;
                    }
                });
                return request.post(`${baseUrl}/_search`, criteria, { ...config });
            },
            delete(context, { id, config }) {
                return request.post(`${baseUrl}/_delete`, JSON.stringify(id), { ...config });
            },
            deleteAll(context, { ids, config }) {
                return request.post(`${baseUrl}/_delete_all`, ids, { ...config });
            },
            active(context, { id, config }) {
                return request.post(`${baseUrl}/_active`, JSON.stringify(id), { ...config });
            },
            activeAll(context, { ids, config }) {
                return request.post(`${baseUrl}/_active_all`, ids, { ...config });
            },
            rev(context, { id, criteria, config }) {
                return request.post(`${baseUrl}/${id}/_rev`, criteria, { ...config });
            },
            changes(context, { id, criteria, config }) {
                return request.post(`${baseUrl}/${id}/_changes`, criteria, { ...config });
            },
            findAll(context, { criteria, config, options }) {
                criteria = lodash.merge(
                    {
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        where: [{ name: "isActive", type: "Boolean", operator: "=", value: true }],
                        sort: [{ name: "updateDate", type: "DESC" }]
                    },
                    criteria
                );
                options = lodash.merge(
                    {
                        cache: true,
                        force: false,
                        ...options
                    },
                    options
                );
                if (context.state.cacheDate.list && context.state.cacheDate.list.isBefore(moment())) {
                    options.force = true;
                }
                const list = context.state.list;
                if (list.length > 0 && !options.force) {
                    return new Promise(reslove => reslove(list));
                }
                return request.post(`${baseUrl}/_search`, criteria, { ...config }).then(page => {
                    if (options.cache) {
                        context.commit("setList", page.data);
                    }
                    return page.data;
                });
            },
            cacheFindAll(context, { where, sort, criteria = { select: ["*"] }, options }) {
                let force = options?.force ? options.force : false;
                const cacheDateResult = context.state.cacheDate.list;
                if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                    force = true;
                }
                const list = context.state.list || [];
                if (list.length > 0 && !force) {
                    return filter({ list, where, sort });
                }
                return context.dispatch("findAll", { criteria }).then(list => filter({ list, where, sort }));
            }
        };
        this.mutations = {
            setList(state, list) {
                state.list = list;
                state.cacheDate.list = moment().add(cacheTime, "ms");
            }
        };
    }
}
